<template>
	<label class="ms-checkbox">
		<input
			type="checkbox"
			:value="value"
			:checked="value"
			:disabled="disabled"
			v-on="listeners"
		/>
		<span class="checkmark">
			<div
				:class="[
					{ focused: focused },
					'mi',
					'mi-18',
					disabled ? 'mi-checkbox-active-disabled' : 'mi-checkbox-active',
				]"
				v-show="value"
			></div>
			<div
				:class="[
					{ focused: focused },
					'mi',
					'mi-18',
					disabled
						? 'mi-checkbox-non-active-disabled'
						: 'mi-checkbox-non-active',
				]"
				v-show="!value"
			></div>
		</span>
		<span v-if="title" class="ms-checkbox--title">{{ title }}</span>
	</label>
</template>
<script>
export default {
	name: 'msCheckbox',
	props: {
		value: {},
		title: {
			default: null,
			type: String,
		},
		disabled: {
			default: false,
			type: Boolean,
		},
	},
	methods: {
		onFocus(e) {
			const me = this;
			me.focused = true;
		},
		onBlur(e) {
			const me = this;
			me.focused = false;
		},
	},
	data() {
		return {
			focused: false,
		};
	},
	computed: {
		listeners() {
			const me = this;
			return {
				click: (event) => {
					me.$emit('click', event);
				},
				input: (event) => {
					me.$emit('input', !me.value);
				},
				change: (event) => {
					me.$emit('change', me.value);
				},
				focus: (event) => {
					me.onFocus(event);
				},
				blur: (event) => {
					me.onBlur(event);
				},
			};
		},
	},
};
</script>
<style lang="scss" scoped>
@media screen and (max-width: 1366px) {
	@import '@/assets/scss/_sm-variables.scss';
	@import '@/assets/scss/components/msCheckbox.scss';
}
@media screen and (min-width: 1367px) {
	@import '@/assets/scss/_variables.scss';
	@import '@/assets/scss/components/msCheckbox.scss';
}
</style>